interface LanguageAvailable {
  FR: string;
  EN: string;
  [key:string]: string
}
export const Language: LanguageAvailable = {
  FR: 'fr',
  EN: 'en',
};
